<template>
    <div class="mb-8">
        <inertia-link href="/">
            <img :src="source" class="m-auto p-auto" alt="SH TAX">
        </inertia-link>
    </div>
</template>

<script>
export default {
    props: {
        source: {
            type: String,
            default: '/img/shtax_200.png',
        }
    }
}
</script>